import React, { FormEvent, useState } from "react";
import "./Style/ForgotPassword.css";
import Loading from "../Common/Loading";

const ForgotPassword: React.FC = () => {
    const query = new URLSearchParams(window.location.search);
    const schoolCode = query.get("S")?.trim() || "";
    const login = query.get("L")?.trim() || "";
    const userType = query.get("UserType") || "FamilyLogin";
    const isPasswordReset = Boolean(schoolCode && login);

    const [email, setEmail] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const configuredApiUrl = process.env.REACT_APP_DOCUMENT_LINK?.trim();
    const isLocalHost = (hostname: string) =>
        hostname === "localhost" || hostname === "127.0.0.1";
    const configuredApiIsLocal = configuredApiUrl
        ? isLocalHost(new URL(configuredApiUrl, window.location.origin).hostname)
        : false;
    const apiBaseUrl = !configuredApiUrl ||
        (configuredApiIsLocal && !isLocalHost(window.location.hostname))
        ? `${window.location.origin}/api/`
        : configuredApiUrl.endsWith("/")
            ? configuredApiUrl
            : `${configuredApiUrl}/`;
    const forgotPasswordApiUrl = new URL("forgot-password/", apiBaseUrl).toString();

    const handleCancel = () => {
        window.close();
    };

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setErrorMessage("");
        setSuccessMessage("");

        if (isPasswordReset) {
            if (!newPassword || !confirmPassword) {
                setErrorMessage("Please enter and confirm your new password.");
                return;
            }
            if (newPassword !== confirmPassword) {
                setErrorMessage("New Password and Confirm Password should be the same.");
                return;
            }
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!email.trim()) {
                setErrorMessage("Email is not provided.");
                return;
            }
            if (!emailRegex.test(email.trim())) {
                setErrorMessage("Invalid Email Format.");
                return;
            }
        }

        setIsLoading(true);
        try {
            const response = await fetch(forgotPasswordApiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(
                    isPasswordReset
                        ? {
                            userType,
                            schoolCode,
                            login,
                            newPassword,
                            confirmPassword,
                        }
                        : { userType, email: email.trim() }
                ),
            });
            const data = await response.json();

            if (!response.ok || !data.success) {
                throw new Error(data.message || data.error || "Unable to reset your password. Please try again.");
            }

            setSuccessMessage(
                isPasswordReset
                    ? "Your Password has been Reset Successfully."
                    : "Please check your Mail to Reset Password."
            );
        } catch (error) {
            setErrorMessage(
                error instanceof Error
                    ? error.message
                    : "Unable to reset your password. Please try again."
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            {isLoading && <Loading />}
            <div id="divForgotPassword">
                {!successMessage ? (
                    <form noValidate onSubmit={handleSubmit}>
                        {isPasswordReset ? (
                            <>
                                <p>
                                    <span className="title_text">Reset Password</span>
                                    <span id="ar_text1">Please enter your New Password.</span>
                                    <label id="fp_form_NPwd" htmlFor="txtNewPassword">
                                        New Password <br/>
                                        <input
                                            id="txtNewPassword"
                                            className="login_field reset_password_field"
                                            type="password"
                                            maxLength={30}
                                            autoComplete="new-password"
                                            value={newPassword}
                                            onChange={(event) => setNewPassword(event.target.value)}
                                        />
                                    </label>
                                    <label id="fp_form_CPwd" htmlFor="txtConfirmPassword">
                                        Confirm Password <br/>
                                        <input
                                            id="txtConfirmPassword"
                                            className="login_field reset_password_field"
                                            type="password"
                                            maxLength={30}
                                            autoComplete="new-password"
                                            value={confirmPassword}
                                            onChange={(event) => setConfirmPassword(event.target.value)}
                                        />
                                    </label>
                                </p>
                            </>
                        ) : (
                            <p>
                                <span className="title_text">Account Recovery</span>
                                <span id="ar_text">Please enter the email address you used when you signed up.</span>
                                <label id="fp_form_box" htmlFor="txtEmail">
                                    <input
                                        id="txtEmail"
                                        type="email"
                                        className="login_field login_fp"
                                        placeholder="Email"
                                        maxLength={200}
                                        autoComplete="email"
                                        value={email}
                                        onChange={(event) => setEmail(event.target.value)}
                                    />
                                </label>
                            </p>
                        )}
                        {errorMessage && <p className="forgot_password_message" role="alert">{errorMessage}</p>}
                        <div className="button_box">
                            <button
                                type="button"
                                id="linkbtnCancelBtn"
                                className="general_btn two_btn_lightbox two_btn_left"
                                onClick={handleCancel}
                            >
                                <span>Cancel</span>
                            </button>
                            <button
                                type="submit"
                                id="linkbtnSubmit"
                                className="general_btn two_btn_lightbox"
                                disabled={isLoading}
                            >
                                <span>{isLoading ? "Submitting..." : "Submit"}</span>
                            </button>
                        </div>
                    </form>
                ) : (
                    <>
                        <p>
                            <span className="title_text">Account Recovery</span>
                            <span id="ar_text">{successMessage}</span>
                        </p>
                        <button
                            type="button"
                            className="general_btn two_btn_lightbox"
                            onClick={() => { window.location.href = "/"; }}
                        >
                            <span>OK</span>
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;
